export const LANG = process.env.VUE_APP_I18N_LOCALE;
export const LANG_FALLBACK = process.env.VUE_APP_I18N_FALLBACK_LOCALE;
export const ENV = process.env.NODE_ENV;
export const API = process.env.VUE_APP_API;
export const JCC_LINK = process.env.VUE_APP_JCC_LINK;
export const JCC_REDIRECT_LINK = process.env.VUE_APP_JCC_REDIRECT_LINK;
export const JCC_PASSWORD = process.env.VUE_APP_JCC_PASSWORD;
